import { render, staticRenderFns } from "./Webinar.vue?vue&type=template&id=962ed3d8&"
import script from "./Webinar.vue?vue&type=script&lang=js&"
export * from "./Webinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports